import { MatomoProvider } from '@datapunt/matomo-tracker-react';
import { useMemo, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { withIsActiveGuard } from '../../utils';
import { MODULE_NAME } from '../model/constant';
import { getMatomoInstance, getSettings } from '../model/utils';
import { useModuleSettingsByName } from '../../../global-hooks';
import { emptyNull } from '../../../shared/misc';
import { ACCEPTED_ALL } from '../../../components/core/CookieBanner/CookieBanner';

const MatomoProviderWrapper = ({ children }) => {
  const config = getSettings();
  const cookieBannerSettings = useModuleSettingsByName('cookieBanner') ?? emptyNull;
  const { cookieName = 'vsx_cookie', isActive: cookieBannerEnabled } = cookieBannerSettings ?? emptyNull;
  const [consent, setConsent] = useState(() => Cookies.get(cookieName));

  const consentGranted = !cookieBannerEnabled || consent === ACCEPTED_ALL;

  const matomoInstance = useMemo(
    () => (consentGranted ? getMatomoInstance(config) : null),
    [consentGranted, config]
  );

  useEffect(() => {
    const handler = () => setConsent(Cookies.get(cookieName));
    window.addEventListener('cookieConsentUpdated', handler);
    return () => window.removeEventListener('cookieConsentUpdated', handler);
  }, []);

  if (!matomoInstance) return <>{children}</>;

  return <MatomoProvider value={matomoInstance}>{children}</MatomoProvider>;
};

export default withIsActiveGuard(MODULE_NAME)(MatomoProviderWrapper);
